import { Routes } from '@angular/router';
import { ErrorComponent } from './pages/error/error.component';
import { AuthGuard } from './guards/auth.guard';
import { Auth2Guard } from './guards/auth2.guard';

export const ROUTES: Routes = [{
  path: '', redirectTo: 'app', pathMatch: 'full'
},
{
  path: 'app', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [AuthGuard]
},
{
  path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule), canActivate: [Auth2Guard]
},
{
  path: 'wmsbyit', loadChildren: () => import('./pages/wmsbyit/wmsbyit.module').then(m => m.WMSByITModule)
},
{
  path: 'ymstrack', loadChildren: () => import('./pages/ymstrack/ymstrack.module').then(m => m.YMSTrackModule)
},
{
  path: 'updymsrelease', loadChildren: () => import('./pages/updymsrelease/updymsrelease.module').then(m => m.UPDYMSReleaseModule)
},
{
  path: 'error', component: ErrorComponent
},
{
  path: '**', component: ErrorComponent
}
];
